export enum HotelSorting {
  POPULARITY = 'Popularity',
  PRICE_ASC = 'PriceAsc',
  PRICE_DESC = 'PriceDesc',
  RATE_ASC = 'RateAsc',
  RATE_DESC = 'RateDesc',
  POINT_ASC = 'PointAsc',
  POINT_DESC = 'PointDesc',
}
